import { addNotification } from 'components/Notifications/actions'
import { BASE_URL } from 'config'
import { saveAutomatedPanelInfo } from 'pages/InputView/helpers/saveAutomatedPanel'
import { synapse } from 'state'

const setNotications = (startedNotificationText, pendingNotificationText) => {
  if (startedNotificationText)
    addNotification({ message: startedNotificationText })
  setTimeout(() => {
    if (pendingNotificationText)
      addNotification({ message: pendingNotificationText })
  }, 500)
}

const createImportApiInstance = () => {
  const baseParams = ['lng']
  const _private = {}

  return {
    setLanguage(lang) {
      _private.lng = lang
    },
    createFormDataWithBaseParams(files) {
      const formData = new FormData()
      baseParams.forEach((param) => {
        formData.set(param, _private[param])
      })

      files.forEach((file) => {
        formData.append('file', file)
      })
      return formData
    },
    async importInstance({
      id,
      file,
      truncate,
      startedNotificationText,
      pendingNotificationText,
      t
    }) {
      const formData = this.createFormDataWithBaseParams(file)
      if (truncate) formData.set('truncate', true)
      saveAutomatedPanelInfo('IMPORT', {
        instance: id
      })
      setNotications(startedNotificationText, pendingNotificationText)

      await synapse.fetch(
        `${BASE_URL}/instances/${id}/import`,
        { method: 'POST' },
        formData
      )
    },
    async importWorkingTableGroup({
      instanceId,
      wtGroup,
      file,
      startedNotificationText,
      pendingNotificationText,
      t
    }) {
      const formData = this.createFormDataWithBaseParams(file)
      formData.set('group', wtGroup)
      saveAutomatedPanelInfo('IMPORT', {
        instance: instanceId,
        group: wtGroup
      })
      setNotications(startedNotificationText, pendingNotificationText)

      await synapse.fetch(
        `${BASE_URL}/instances/${instanceId}/import`,
        { method: 'POST' },
        formData
      )
    },
    async importWorkingTable({
      id,
      file,
      startedNotificationText,
      pendingNotificationText,
      t
    }) {
      const formData = this.createFormDataWithBaseParams(file)
      saveAutomatedPanelInfo('IMPORT', {
        wt: id
      })
      setNotications(startedNotificationText, pendingNotificationText)

      await synapse.fetch(
        `${BASE_URL}/workingtables/${id}/import`,
        { method: 'POST' },
        formData
      )
    },
    async importDocumentsByType({
      wtID,
      type,
      file,
      startedNotificationText,
      pendingNotificationText,
      t
    }) {
      const formData = this.createFormDataWithBaseParams(file)
      saveAutomatedPanelInfo('IMPORT', {
        wt: wtID,
        documentType: type
      })

      setNotications(startedNotificationText, pendingNotificationText)

      await synapse.fetch(
        `${BASE_URL}/workingtables/${wtID}/${type}/import`,
        { method: 'POST' },
        formData
      )
    },
    async importDocument({
      wtType,
      activityId,
      id,
      field,
      file,
      startedNotificationText,
      pendingNotificationText,
      t
    }) {
      const formData = this.createFormDataWithBaseParams(file)
      if (field) formData.set('item', field)
      const payloadNotification = {
        documentType: wtType,
        wt: activityId,
        documentId: id
      }
      if (field) {
        payloadNotification.item = field
      }
      saveAutomatedPanelInfo('IMPORT', payloadNotification)

      setNotications(startedNotificationText, pendingNotificationText)

      await synapse.fetch(
        `${BASE_URL}/${wtType}/import/${activityId}/${id}`,
        { method: 'POST' },
        formData
      )
    },
    async importScenarioFile({
      configProperties,
      file,
      startedNotificationText,
      pendingNotificationText,
      t
    }) {
      const formData = this.createFormDataWithBaseParams(file)
      if (configProperties) formData.set('configProperties', JSON.stringify(configProperties))
      const payloadNotification = {}
      if (configProperties) {
        payloadNotification.item = configProperties
      }
      saveAutomatedPanelInfo('IMPORT', payloadNotification)

      setNotications(startedNotificationText, pendingNotificationText)

      await synapse.fetch(
        `${BASE_URL}/scenariosProduct/upload`,
        { method: 'POST' },
        formData
      )
    }
  }
}

export const ImportApi = createImportApiInstance()
